<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import {getToken} from "@/api/systemSetting";
import $store from '@/store';
import {getCityInfo} from "@/api/interfaceApi";
import {serviceNode} from "@/api/cloudServiceApi";
import cityJson from "@/static/cityJson.json";
export default {
  name: 'app',
  data() {
    return {
      beforeUnload_time: 0,
      gap_time: 0,
      screenWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      pinyinItem: [
        {type: 'beijing', name: '京'},
        {type: 'tianjin', name: '津'},
        {type: 'hebei', name: '冀'},
        {type: 'shanxi', name: '晋'},
        {type: 'neimenggu', name: '蒙'},
        {type: 'liaoning', name: '辽'},
        {type: 'jilin', name: '吉'},
        {type: 'heilongjiang', name: '黑'},
        {type: 'shanghai', name: '沪'},
        {type: 'jiangsu', name: '苏'},
        {type: 'zhejiang', name: '浙'},
        {type: 'fujian', name: '闽'},
        {type: 'jiangxi', name: '赣'},
        {type: 'shandong', name: '鲁'},
        {type: 'henan', name: '豫'},
        {type: 'hubei', name: '鄂'},
        {type: 'hunan', name: '湘'},
        {type: 'guangdong', name: '粤'},
        {type: 'guangxi', name: '桂'},
        {type: 'hainan', name: '琼'},
        {type: 'chongqing', name: '渝'},
        {type: 'sichuan', name: '川'},
        {type: 'guizhou', name: '黔'},
        {type: 'yunnan', name: '滇'},
        {type: 'xizang', name: '藏'},
        {type: 'shaanxi', name: '陕'},
        {type: 'gansu', name: '甘'},
        {type: 'qinghai', name: '青'},
        {type: 'ningxia', name: '宁'},
        {type: 'xinjiang', name: '新'},
        {type: 'anhui', name: '皖'},
      ]
    }
  },
  watch: {
    screenWidth(val) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = val;
        this.timer = true;
        let that = this;
        setTimeout(function () {
          that.timer = false;
        }, 400);
      }
    },
  },
  destroyed() {
    window.removeEventListener("beforeunload", () => this.beforeunloadHandler());
    window.removeEventListener("unload", () => this.unloadHandler());
  },
  mounted() {
    window.addEventListener("beforeunload", () => this.beforeunloadHandler());
    window.addEventListener("unload", () => this.unloadHandler());
    const that = this;
    window.onresize = () => {
      return (() => {
        (window.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth), (that.screenWidth = window.screenWidth);
        this.fun();
      })();
    }
  },
  methods: {
    // 关闭窗口之前执行
    beforeunloadHandler() {
      this.beforeUnload_time = new Date().getTime();
    },
    unloadHandler() {
      this.gap_time = new Date().getTime() - this.beforeUnload_time;
    },
    // 设置html标签的字体大小自适应   为了使得rem单位自适应
    fun() {
      const that = this;
      let htmlObj = document.getElementsByTagName("html")[0];
      htmlObj.style.fontSize = (that.screenWidth / 1920) * 16 + "px";
    },
    /**获取地图定位*/
    getMapArea(){
      const that = this;
      if (!sessionStorage.getItem('locationInfo')) {
        let url = window.location.href;
        // url = 'http://beijing.bangqichat.com'
        if (url.indexOf('www') > -1) {
          let str = url.split('://www.')
          let str1 = str[1].split('.');
          let pinyin = str1[0];
          for (let a = 0; a < this.pinyinItem.length; a++) {
            if (this.pinyinItem[a].type == pinyin) {
              for (let li of cityJson) {
                if (this.pinyinItem[a].name == li.abridge) {
                  document.title = li.abridge+'企服务云';
                  that.getCityCode(li.lng, li.lat);
                }
              }
            }
          }
        } else {
          let str = url.split('://')
          let str1 = str[1].split('.');
          let pinyin = str1[0];
          for (let a = 0; a < this.pinyinItem.length; a++) {
            if (this.pinyinItem[a].type == pinyin) {
              for (let li of cityJson) {
                if (this.pinyinItem[a].name == li.abridge) {
                  document.title = li.abridge+'企服务云';
                  that.getCityCode(li.lng, li.lat);
                }
              }
            }
          }
        }
      }
    },
    getCityCode(lat,lng){
      getCityInfo(lat, lng, 1).then(res => {
        $store.state.locationInfo = res.content;
        sessionStorage.setItem("locationInfo", JSON.stringify(res.content));
        localStorage.setItem("locationInfo", JSON.stringify(res.content));
        serviceNode({cityCode: res.content.id, request: 'form', uid: 0}).then(obj => {
          if (obj.code == 200){
            $store.commit('SET_ChildNodes', JSON.stringify(obj.content.list));
            for (let a=0;a<obj.content.list.length;a++){
              if (a==0){
                $store.commit('SET_CHILD_NODE', JSON.stringify(obj.content.list[0]));
              }
            }
          }
        })
      })
    },
  },
  beforeMount() {
    if (localStorage.getItem('token') == '' || localStorage.getItem('token') == null || localStorage.getItem('token') == undefined){
      getToken({timestamp: '0', uid: 0, request: 'form'}).then(res => {
        if (res.code == 200) {
          $store.state.token=res.content;
          sessionStorage.setItem("token", res.content);
          localStorage.setItem("token", res.content);
        }
      })
    }
    this.getMapArea();
  }
}
</script>

<style>
body {
  margin: 0px;
  background: #E7E9F5;
}
</style>
